import React from "react";
import PageHero from "../components/PageHero";
import SectionHeader from "../components/SectionHeader";
import CTASection from "../components/CTASection";
import { COMPANY, SCOPE_TABLE } from "../lib/constants";

export default function GovProfile() {
  return (
    <div>
      <PageHero
        kicker="Vendor / Tender Profile"
        title="Government Contractor & Institutional Vendor Profile"
        description="Government contractor-ready profile suitable for tender enquiries, vendor registration, empanelment, and institutional supply."
        primary={{ to: "/submit", label: "Submit Tender Enquiry" }}
        secondary={{ to: "/downloads", label: "Request Vendor Documents" }}
      />

      <section className="section">
        <div className="container-x grid lg:grid-cols-2 gap-8">
          <div>
            <SectionHeader kicker="Company Legal Details" title="Registered Identifiers" />
            <div className="card-premium overflow-hidden mt-4">
              <table className="w-full table-clean">
                <tbody>
                  {[
                    ["Company Name", COMPANY.name],
                    ["Business Type", "Private Limited Company"],
                    ["Location", COMPANY.address],
                    ["CIN", COMPANY.cin],
                    ["GSTIN", COMPANY.gstin],
                    ["MSME / Udyam", COMPANY.msme],
                    ["FSSAI", COMPANY.fssai],
                  ].map(([k, v]) => (
                    <tr key={k}>
                      <td className="font-semibold text-navy w-1/3">{k}</td>
                      <td>{v}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div>
            <SectionHeader kicker="Business Nature" title="What We Do" />
            <p className="text-[15px] text-[var(--melopa-text)] mt-3">
              Supplier, government contractor, institutional procurement partner, infrastructure solutions provider, renewable energy and lighting solutions partner, bulk fulfilment company.
            </p>
            <SectionHeader kicker="Documentation Available" title="Vendor Documents" />
            <ul className="list-tick mt-2">
              <li>Company Profile (Public)</li>
              <li>GST, MSME and FSSAI Certificates (On Request)</li>
              <li>Authorisation Letters & Bank Details (On Request)</li>
              <li>Tender / Empanelment Documents (On Request)</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section bg-soft">
        <div className="container-x">
          <SectionHeader kicker="Scope of Work" title="Categories & Capabilities" />
          <div className="card-premium overflow-x-auto mt-6 scroll-shadow">
            <table className="w-full table-clean min-w-[720px]">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Scope</th>
                </tr>
              </thead>
              <tbody>
                {SCOPE_TABLE.map(([c, s]) => (
                  <tr key={c}>
                    <td className="font-semibold text-navy whitespace-nowrap">{c}</td>
                    <td>{s}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-xs text-[var(--melopa-muted)] mt-4 max-w-3xl">
            Melopa Invents supports supply, sourcing, installation coordination, project fulfilment, and execution support through qualified technical partners, OEMs, channel partners, and licensed professionals wherever required.
          </p>
        </div>
      </section>

      <CTASection
        title="Vendor / Tender Registration Enquiry?"
        description="Share your tender details, empanelment forms or product specifications. We will revert with the suitable documents and pricing."
      />
    </div>
  );
}
